import { buildTopicUpdatedText } from '@src/utility/topicPrefixUtils';
import { useCallback, useState } from 'react';

/**
 * Manages topic filter selection and syncs a "Topics: ..." prefix
 * into a text field via the provided setter.
 */
export function useTopicFilter(
  currentText: string,
  setText: (text: string) => void,
) {
  const [selectedTopics, setSelectedTopics] = useState<string[]>([]);

  const handleTopicsApply = useCallback(
    (topics: string[]) => {
      const updated = buildTopicUpdatedText(
        selectedTopics,
        topics,
        currentText,
      );
      setText(updated);
      setSelectedTopics(topics);
    },
    [selectedTopics, currentText, setText],
  );

  return { selectedTopics, handleTopicsApply };
}
